import request from "../utils/request";

export const pubInfo = () =>request({
    method: 'GET',
    url: '/pubInfo',
})
